import { useState } from 'react';
import { CadPreview } from './cad-preview';
import { Sidebar } from './sidebar';

export const Settings = () => {
  const [selectedWorkstation, setSelectedWorkstation] = useState<string>();

  return (
    <div
      className="relative h-full w-full flex items-stretch overflow-hidden"
      style={{ minHeight: 'calc(100vh - 90px)' }}>
      <Sidebar>
        {selectedWorkstation && (
          <div className="mt-4 flex flex-col gap-4">
            <h3 className="text-lg font-bold">
              Stazione {selectedWorkstation}
            </h3>
          </div>
        )}
      </Sidebar>
      <CadPreview
        selectedWorkstation={selectedWorkstation}
        onSelectWorkstation={(w) => setSelectedWorkstation(w)}
      />
    </div>
  );
};
